import React, {Fragment} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {H2} from "@irati/ui/src/Typography/Heading"
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList"

import Leaderboard from "../../Leaderboard"
import {CompanyValuesWrapper, Top, Bottom, EndDate, TeamList, BigDesc} from "../shared/layouts"
import Votes from "../shared/Votes"
import WhoVoted from "../../WhoVoted"

const WhoVotedContainer = styled.div`
  margin-top: ${padding.tiny};
  display: flex;
  justify-content: center;
`

const ViewVotes = ({poll}) => {
  return (
    <Fragment>
      <Top className="center">
        <TeamList teams={poll.teams.results} />
        <H2 withBody bold>
          {poll.title}
        </H2>
        <BigDesc>{poll.desc}</BigDesc>
        <WhoVotedContainer>
          <WhoVoted poll={poll} />
        </WhoVotedContainer>
        <CompanyValuesWrapper>
          <CompanyValues companyValues={poll.companyValues} />
        </CompanyValuesWrapper>
        <EndDate endsAt={poll.endsAt} />
        <Leaderboard poll={poll} size={50} />
      </Top>
      <Bottom>
        <Votes poll={poll} />
      </Bottom>
    </Fragment>
  )
}

ViewVotes.propTypes = {
  poll: PropTypes.object.isRequired
}

ViewVotes.defaultProps = {
  id: "view-votes"
}

export default ViewVotes
